import React from 'react';

import {
  EducationContainer,
  EducationH1,
  EducationWrapper,
  EducationCard,
  EducationH2,
  Educations,
  EducationH3,
  EducationH4,
  EducationP,
  Bar,
  CircleDot,
  DocumentBtn,
} from './EducationElements';

const Education = () => {
  return (
    <EducationContainer id="education">
      <EducationWrapper>
        <EducationH1>Education</EducationH1>
        <Educations>
          <EducationCard isFirst>
            <Bar isFirst />
            <CircleDot isFirst />
            <EducationH2>
              Bachelor of Technology in Production Engineering
            </EducationH2>
            <EducationH3>Vishwakarma Institute of Technology, Pune</EducationH3>
            <EducationH4>2019 - 2023</EducationH4>
            <EducationP>CGPA - 9.27</EducationP>
            <DocumentBtn
              isFirst
              as="a"
              href="https://drive.google.com/file/d/1NLefrHzbZeKdiCMHXEC5uX3KIThqqT-U/view?usp=sharing"
              target="_blank"
            >
              View Doc
            </DocumentBtn>
          </EducationCard>
          <EducationCard>
            <Bar />
            <CircleDot />
            <EducationH2>Higher Secondary Education</EducationH2>
            <EducationH3>Vidya Bhavan Junior College</EducationH3>
            <EducationH4>2017 - 2019</EducationH4>
            <EducationP>Percentage - 84.16%</EducationP>
            <DocumentBtn
              as="a"
              href="https://drive.google.com/file/d/1aV5ONMP17Uq-cDfLzB8RFYMeGONOfgRo/view?usp=sharing"
              target="_blank"
            >
              View Doc
            </DocumentBtn>
          </EducationCard>
          <EducationCard>
            <Bar isLast />
            <CircleDot />
            <EducationH2>Matriculation</EducationH2>
            <EducationH3>St. Joseph Boys' High School, Pune</EducationH3>
            <EducationH4>2007 - 2017</EducationH4>
            <EducationP>Percentage - 87.60%</EducationP>
            <DocumentBtn
              as="a"
              href="https://drive.google.com/file/d/1hv7urEjNBp47F4ULeG2XmNkdW6kVE7BQ/view?usp=sharing"
              target="_blank"
            >
              View Doc
            </DocumentBtn>
          </EducationCard>
        </Educations>
      </EducationWrapper>
    </EducationContainer>
  );
};

export default Education;
